import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getJogosCampos } from '../../store/actions';
import { Card, Row, Col, Spinner, Form, FloatingLabel, Button } from 'react-bootstrap';
import CamposGrid from './camposGrid';
import MainLayout from '../../hoc/mainLayout';
import jsPDF from 'jspdf';
import { autoTable } from 'jspdf-autotable'
import banner from "../../assets/letras_banner.png"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const ls_campo = () => localStorage.getItem('campo_selected') || 'none';

const Campos = () => {
    const jogosCampos = useSelector(state => state.campos.campos);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getJogosCampos());
    }, [dispatch]);

    const [{ campo_selected, dia_selected }, setData] = useState({
        campo_selected: ls_campo(),
        dia_selected: 0
    });

    const [campos, setCampos] = useState(null);

    const calculaCampos = (jogos) => {
        const result = [];
        const uniqueCamposSet = new Set();

        for (const jogo of jogos) {
            const { nomecampo, campos_id } = jogo;
            if (!uniqueCamposSet.has(campos_id)) {
                result.push({ campos_id, nomecampo });
                uniqueCamposSet.add(campos_id);
            }
        }

        return result.sort((a, b) => b.campos_id - a.campos_id);
    }

    useEffect(() => {
        if (jogosCampos && jogosCampos.length > 0) {
            const camposResult = calculaCampos(jogosCampos);
            setCampos(camposResult);
        }
    }, [jogosCampos]);

    function handleCampoChange(event) {
        setData(data => ({ campo_selected: event.target.value, dia_selected: 0 }));
        localStorage.setItem('campo_selected', event.target.value);
    }

    function handleDiaChange(event) {
        setData(data => ({ ...data, dia_selected: event.target.value }));
    }

    const exportToPDF = () => {
        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4'
        });

        // Add banner image
        const img = new Image();
        img.src = banner// Update with the correct path to your image
        img.onload = () => {
            doc.addImage(img, 'PNG', 20, 5, 30, 15,'','FAST'); // Adjust dimensions and position as needed

            // Define column headers matching your grid
            const columnHeaders = [
                'Dia',
                'Hora',
                'Jogo',
                'Campo',
                'Referência',
                'Escalão',
                'Grupo',
                'Equipa Casa',
                'Balneário Casa',
                'N_Casa',
                'Equipa Fora',
                'Balneário Fora',
                'N_Fora',
                'Num Campo',
                'Total',
                'Id Jogo'
            ];

            // Extract row data matching your grid columns
            const tableData = jogosCampos_filtered.map(jogo => [
                jogo.dia,
                jogo.hora,
                jogo.JOGO,
                jogo.campo,
                jogo.referencia,
                jogo.escalao,
                jogo.grupo,
                jogo.nomecasa,
                jogo.balneariocasa,
                jogo.njogadorescasa,
                jogo.nomefora,
                jogo.balneariofora,
                jogo.njogadoresfora,
                jogo.numcampo,
                jogo.totaljogadores,
                jogo.id
            ]);

            // Add table to PDF
            autoTable(doc, {
                head: [columnHeaders],
                body: tableData,
                startY: 20, // Position below the banner
                styles: {
                    fontSize: 7, // Smaller font to fit all columns
                    cellPadding: 1,
                    cellWidth: 'wrap'
                },
                margin: { left: 5, right: 5 }
            });

            const nome_campo = campos ? campos.find(c => c.campos_id == campo_selected)?.nomecampo : 'Todos';
            const filename = `jogos_${nome_campo}_${new Date().toISOString()}.pdf`;

            // Save the PDF
            doc.save(filename);
            doc.output('pdfobjectnewwindow');
        };

        // Fallback if image fails to load
        img.onerror = () => {
            // Add table without image
            const columnHeaders = [
                'Dia', 'Hora', 'Jogo', 'Campo', 'Referência', 'Escalão', 'Grupo',
                'Equipa Casa', 'Balneário Casa', 'N_Casa', 'Equipa Fora',
                'Balneário Fora', 'N_Fora', 'Num Campo', 'Total', 'Id Jogo'
            ];

            const tableData = jogosCampos_filtered.map(jogo => [
                jogo.dia, jogo.hora, jogo.JOGO, jogo.campo, jogo.referencia,
                jogo.escalao, jogo.grupo, jogo.nomecasa, jogo.balneariocasa,
                jogo.njogadorescasa, jogo.nomefora, jogo.balneariofora,
                jogo.njogadoresfora, jogo.numcampo, jogo.totaljogadores, jogo.id
            ]);

            autoTable(doc, {
                head: [columnHeaders],
                body: tableData,
                startY: 20,
                styles: {
                    fontSize: 6,
                    cellPadding: 1
                },
                margin: { left: 5, right: 5 }
            });

            doc.save('jogos_campos.pdf');
        };
    };

    const campos_data = campos ? [<option key="campos-0" value="0">Todos</option>, campos?.map((item) => (
        <option key={`campos-${item.campos_id}`} value={item.campos_id}>
            {item.nomecampo}
        </option>
    ))] : null;

    const dia_data = [
        <option key="dias-1" value="0">Todos</option>,
        <option key="dias-2" value="19">19</option>,
        <option key="dias-3" value="20">20</option>,
        <option key="dias-4" value="21">21</option>,
    ];

    const jogosCampos_filtered = jogosCampos && campos ? jogosCampos.filter(jogo => (campo_selected == 0 || jogo.campos_id == campo_selected) && (dia_selected == 0 || jogo.dia == dia_selected)) : [];

    return (
        <>
            {jogosCampos && campos ? (
                <>
                    <MainLayout>
                        <Card>
                            <Card.Header>
                                <Card.Title>Selecionar Campos</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Row className='mb-3'>
                                    <Col>
                                        <FloatingLabel controlId="floatingSelect" label="Campo">
                                            <Form.Select aria-label="Campo"
                                                onChange={handleCampoChange}
                                                value={campo_selected}>
                                                {campos_data}
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Col>
                                </Row>
                                <Row className='mb-3'>
                                    <Col>
                                        <FloatingLabel controlId="floatingSelect"
                                            label="Dia">
                                            <Form.Select aria-label="Dia"
                                                onChange={handleDiaChange}
                                                value={dia_selected}>
                                                {dia_data}
                                            </Form.Select>
                                        </FloatingLabel>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="text-start">
                                        <Button 
                                            variant="primary" 
                                            size="sm" 
                                            onClick={exportToPDF}
                                            className="d-flex align-items-center gap-1"
                                        >Exportar PDF</Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </MainLayout>
                    <br />
                    <div className="root-grid">
                        <CamposGrid jogos={jogosCampos_filtered} />
                    </div>
                </>
            ) : (<Row className="mb-3">
                <Col className="d-flex justify-content-center align-items-center">
                    <Spinner animation="border" variant="secondary" />
                </Col>
            </Row>)
            }
        </>
    );
}

export default Campos;